import { axiosPrivate } from '@app/dashboard/tools/axios/axiosInstance';
import { getCookie } from '../utils/manageCookies';
import { COOKIES_KEYS } from '../constants/cookies-keys';

export const getOldDashboardUserInfo = () => {
  const switchDashboardsToken = getCookie(COOKIES_KEYS.SWITCH_DASHBOARDS_TOKEN);

  const headers = { "Authorization": `Base64 ${switchDashboardsToken}` };

  return axiosPrivate.get(`/dashboard/v1/switch/new-dashboard`, { headers: headers });
};